import Cookies from 'js-cookie'
import { lazy, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import MainLayout from '../layout/MainLayout'
import Loadable from '../layout/ui-components/Loadable'
import { logoutUser } from '../store/actions'
import SearchResults from '../views/search'

const AdminDashboard = Loadable(lazy(() => import('../views/admin/dashboard')))
const AddCampaigns = Loadable(lazy(() => import('../views/campaigns/add-campaigns')))
const CopyFromExisting = Loadable(lazy(() => import('../views/campaigns/copy-from-existing')))
const Accounts = Loadable(lazy(() => import('../views/admin/accounts')))
const UserAccount = Loadable(lazy(() => import('../views/admin/user-account')))
const DetailCampaign = Loadable(lazy(() => import('../views/campaigns/detail-campaign')))
const Requests = Loadable(lazy(() => import('../views/admin/requests')))
const Transactions = Loadable(lazy(() => import('../views/admin/transactions')))
const Feeds = Loadable(lazy(() => import('../views/admin/feeds')))

const Settings = Loadable(lazy(() => import('../views/settings')))
const PageNotFound = Loadable(lazy(() => import('../views/extra/NotFound')))
const AddUser = Loadable(lazy(() => import('../views/admin/add-user')))
const Analytics = Loadable(lazy(() => import('../views/view-analytics')))

export default function AdminRoutes() {
  const dispatch: any = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!Cookies.get('dot-ad-token')) {
      navigate('/')
      dispatch(logoutUser())
    }
    if (
      Cookies.get('dot-ad-token') &&
      (location.pathname === '/login' || location.pathname === '/register')
    ) {
      navigate('/')
    }
  }, [])

  const list = {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '', element: <AdminDashboard /> },
      { path: 'dashboard', element: <AdminDashboard /> },
      { path: 'accounts', element: <Accounts /> },
      { path: 'user-account/:fuid', element: <UserAccount /> },
      { path: 'user-account/:fuid/add-campaigns', element: <AddCampaigns /> },
      { path: 'copy-campaign', element: <AddCampaigns FromOld={true} /> },
      { path: 'user-account/:fuid/add-campaigns-from-existing', element: <CopyFromExisting /> },
      { path: 'user-account/:fuid/edit-campaign/:id', element: <AddCampaigns /> },
      { path: 'user-account/:fuid/detail-campaign/:id', element: <DetailCampaign /> },
      { path: 'user-account/:fuid/view-analytics/:id', element: <Analytics /> },
      { path: 'requests', element: <Requests /> },
      { path: 'transactions', element: <Transactions /> },
      { path: 'feeds', element: <Feeds /> },
      { path: 'settings', element: <Settings /> },
      { path: 'add-user', element: <AddUser /> },
      { path: '*', element: <PageNotFound /> },
      { path: '/searchResults', element: <SearchResults /> }
    ]
  }
  return useRoutes([list])
}
